export const DEFAULT_NAME_PROPERTY = {
  cat: 'Nombre del elemento',
  name: 'name',
}

export const KEY_DEFAULT_NAME_PROPERTY = `${DEFAULT_NAME_PROPERTY.cat}-${DEFAULT_NAME_PROPERTY.name}`
